export default {
      id: "viber-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/sprite.svg#viber-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/viber.svg
// module id = ./assets/svg/viber.svg
// module chunks = 0 1 2